import React from 'react';
import { createStyles, Text, Image, Group, Card, Avatar } from '@mantine/core';
import { themeColors } from '../../config/themeSettings';
import { Link } from 'react-router-dom';
import { useMediaQuery } from '@mantine/hooks';

const NewsCard = ({
  imageSrc,
  category,
  title,
  authorAvatarSrc,
  authorName,
  date,
  newsId,
  source,
}) => {
  const { classes } = useStyles();
  const isMobile = useMediaQuery('(max-width: 768px)');
  return (
    <Link to={`/home/news/${newsId}`} style={{ textDecoration: 'none' }}>
      {!isMobile ? (
        <Card withBorder radius="md" p={0} shadow="sm">
          <Group wrap="nowrap" gap={0}>
            <Image src={imageSrc} height={160} />
            <div className={classes.body}>
              <Text transform="uppercase" color="dimmed" weight={700} size="xs">
                {category}
              </Text>

              <Text className={classes.cardTitle} mt="xs" mb="md">
                {title}
              </Text>

              <Group wrap="nowrap" gap="xs">
                <Group gap="xs" wrap="nowrap">
                  <Avatar size={20} src={authorAvatarSrc} />
                  <Text size="xs">{authorName}</Text>
                </Group>
                <Text
                  size="xs"
                  color="dimmed"
                  lineClamp={1}
                  style={{ maxWidth: '100px' }}>
                  {source}
                </Text>
                <Text size="xs" color="dimmed" style={{ whiteSpace: 'nowrap' }}>
                  {date}
                </Text>
              </Group>
            </div>
          </Group>
        </Card>
      ) : (
        <Card
          shadow="sm"
          p="lg"
          style={{ display: 'flex', padding: 0, margin: 0 }}>
          <Card.Section style={{ marginRight: '1em' }}>
            <Image src={imageSrc} height={140} width={160} fit="cover" />
          </Card.Section>

          <div style={{ alignSelf: 'center' }}>
            <Text transform="uppercase" color="dimmed" weight={700} size="xs">
              {category}
            </Text>

            <Text className={classes.cardTitle} mt="xs" mb="md">
              {title}
            </Text>

            <Group wrap="nowrap" gap="xs">
              <Text size="xs" color="dimmed">
                {date}
              </Text>
            </Group>
          </div>
        </Card>
      )}
    </Link>
  );
};

export default NewsCard;

const useStyles = createStyles(theme => ({
  body: {
    padding: theme.spacing.md,
  },

  cardTitle: {
    fontWeight: 'bold',
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    lineHeight: 1.2,
  },
}));
